"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StringUtils = exports.normalizeAccents = exports.appendPath = void 0;
var string_1 = require("@celo/base/lib/string");
// Exports moved to @celo/base, forwarding them
// here for backwards compatibility
var string_2 = require("@celo/base/lib/string");
Object.defineProperty(exports, "appendPath", { enumerable: true, get: function () { return string_2.appendPath; } });
Object.defineProperty(exports, "normalizeAccents", { enumerable: true, get: function () { return string_2.normalizeAccents; } });
exports.StringUtils = {
    appendPath: string_1.appendPath,
    normalizeAccents: string_1.normalizeAccents,
};
//# sourceMappingURL=string.js.map